module.exports = __webpack_public_path__ + "static/img/terminalIllegal_pic02.ed3313e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminalIllegal/terminalIllegal_pic02.png
// module id = 594
// module chunks = 1